/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Column_RolesInputs */

const en_admin_user_list_column_roles = /** @type {(inputs: Admin_User_List_Column_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`roles`)
};

const de_admin_user_list_column_roles = /** @type {(inputs: Admin_User_List_Column_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rollen`)
};

/**
* | output |
* | --- |
* | "roles" |
*
* @param {Admin_User_List_Column_RolesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_column_roles = /** @type {((inputs?: Admin_User_List_Column_RolesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Column_RolesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_column_roles(inputs)
	return en_admin_user_list_column_roles(inputs)
});